import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec8def28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-active-view" }
const _hoisted_2 = { class: "global-controls" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import {computed, inject, ref, onMounted} from 'vue'
  import {useRoute, useRouter} from 'vue-router'
  import {useStore} from 'vuex'

  import IconButton from '@/components/inputs/IconButton.vue'
  import {t} from '@/lib/i18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveView',
  setup(__props) {

  const bus = inject('bus')
  const connectCount = ref(0)
  const route = useRoute()
  const router = useRouter()
  const store = useStore()

  // on mounted, if locale is ar, change info button to be on the right

  onMounted(() => {
    if (store.state.locale === 'ar') {
      const infoButton = document.querySelector('.info-button')
      infoButton.style.right = 'clamp(22px/2, 1vw, 22px)'
      infoButton.style.left = 'unset'
    }
  })

  const onInfoClick = () => {
    bus.publish({
      event: 'TRACK',
      data: {
        action: '<location> - click  about'
      }
    })

    // get current route
    // if current route is active.splash, go to active.about
    const currentRoute = router.currentRoute.value.name
    if (currentRoute === 'active.about') {
      router.go(-1)
    } else {
      router.push({name: 'active.about'})
    }
  }

  const showBack = computed(() => {
    return route.name !== 'active.splash'
  })

  const showMute = computed(() => {
    return true
  })

  const onBackClick = () => {
    const isMedia = store.state.trackingData.isMedia
    if (isMedia && store.state.trackingData.mediaType == 'video') {
      const videoState = store.getters.videoStatus
      bus.publish({
        event: 'TRACK',
        data: {
          action: '<location> - back video',
          label: videoState
        }
      })
    }

    if (isMedia && store.state.trackingData.mediaType == 'audio') {
      //const videoState = store.getters.videoStatus
      let audioState = store.state.trackingData.mediaKey

      const regex = /\/([^./]+)\./
      const match = audioState.match(regex)

      if (match && match[1]) {
        audioState = match[1]
      }

      bus.publish({
        event: 'TRACK',
        data: {
          action: '<location> - back audio',
          label: audioState
        }
      })
    }

    //router.go(-1)
    router.back()
  }

  const onToggleMute = () => {
    store.state.muted = !store.state.muted
    const muteState = store.state.muted ? 'off' : 'on'

    const isMedia = store.state.trackingData.isMedia
    if (isMedia && store.state.trackingData.mediaType == 'video') {
      const videoState = store.getters.videoStatus
      bus.publish({
        event: 'TRACK',
        data: {
          action: '<location> - volume ' + muteState + ' video',
          label: videoState
        }
      })
    }

    if (isMedia && store.state.trackingData.mediaType == 'audio') {
      //const videoState = store.getters.videoStatus
      let audioState = store.state.trackingData.mediaKey

      const regex = /\/([^./]+)\./
      const match = audioState.match(regex)

      if (match && match[1]) {
        audioState = match[1]
      }

      bus.publish({
        event: 'TRACK',
        data: {
          action: '<location> - volume ' + muteState + ' audio',
          label: audioState
        }
      })
    }
  }

  const muted = computed(() => store.state.muted)

  const muteIcon = computed(() => {
    return muted.value ? 'volume-x' : 'volume-2'
  })

  bus.subscribe({
    event: 'RECONNECT',
    callback() {
      connectCount.value = connectCount.value + 1
    }
  })

  const backText = computed(() => t(store, 'back'))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (_unref(showBack))
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createVNode(IconButton, {
                  class: "back-button header-button",
                  name: "back",
                  priority: "secondary",
                  onClick: onBackClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(backText)), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(showMute))
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createVNode(IconButton, {
                  class: "mute-button header-button",
                  name: _unref(muteIcon),
                  priority: "secondary",
                  onClick: onToggleMute
                }, null, 8, ["name"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(IconButton, {
      class: "info-button header-button",
      name: "info",
      priority: "low",
      onClick: onInfoClick
    }),
    _createVNode(_component_router_view, {
      onVideoStart: _ctx.videoStart,
      onVideoEnd: _ctx.videoEnd
    }, {
      default: _withCtx(({Component}) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          key: _unref(route).fullPath + connectCount.value
        }))
      ]),
      _: 1
    }, 8, ["onVideoStart", "onVideoEnd"])
  ]))
}
}

})